import React from 'react';
import { Helmet } from 'react-helmet-async';
import { sendGAPageview } from '../utils/gaConsent';
import CommonHeader from '../Components/Headers/CommonHeader';
import ActivationErrorContent from '../Components/AccountActivationError/ActivationErrorContent';
import $ from 'jquery';

export default function About() {
  $('.popover').hide();
  sendGAPageview({
    hitType: 'pageview',
    page: '/ConfirmationError',
    title: 'Account Activation',
  });

  return (
    <React.Fragment>
      <Helmet>
        <title>DISGENET: Account Activation Error</title>
        <meta name="description" content="Account activation error." />
      </Helmet>
      <CommonHeader />
      <ActivationErrorContent />
    </React.Fragment>
  );
}
